import { render, staticRenderFns } from "./PhonePermissionSettings.vue?vue&type=template&id=4046fce8&scoped=true"
import script from "./PhonePermissionSettings.vue?vue&type=script&lang=js"
export * from "./PhonePermissionSettings.vue?vue&type=script&lang=js"
import style0 from "./PhonePermissionSettings.vue?vue&type=style&index=0&id=4046fce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046fce8",
  null
  
)

export default component.exports